import React, { useState } from "react";

import { Pressable, Text, View } from "react-native";
import { SideBarMenus } from "components/common/SideBar/sideBarData";
import { FlatList } from "react-native";
import { FONT } from "value/staticValues";

const MENU_WIDTH = 240;


function MenuCategoty({category, clickMenuLinkCb, hoverItem, setHoverItem}) {
    return (
        <View style={{width:MENU_WIDTH}}>
            {
                category.item.sub.length === 0 ?
                <Pressable onHoverIn={()=>{setHoverItem(category.item.name)}} onHoverOut={()=>{setHoverItem(category.item.name)}} style={{marginBottom:10}} onPress={()=>clickMenuLinkCb(category.item.path)}>
                    <Text style={{color:hoverItem === category.item.name ? "#4a77ff":"#ffffff", fontSize:15, fontFamily:hoverItem === category.item.name ? FONT.REGULAR:FONT.BOLD}} >{category.item.name}</Text>
                </Pressable> :
                <Text style={{color:"#ffffff", fontSize:15, fontFamily:FONT.BOLD, marginBottom:30}}>{category.item.name}</Text>
            }
            
            {
                category.item.sub.map((page)=>{
                    return (
                        <Pressable key={page.name} onHoverIn={()=>{setHoverItem(page.name)}} onHoverOut={()=>{setHoverItem(page.name)}} style={{marginBottom:10}} onPress={()=>clickMenuLinkCb(page.path)}>
                            <Text style={{color:hoverItem === page.name ? "#4a77ff":"#c9c9c9", fontSize:14, fontFamily:FONT.REGULAR}}>{page.name}</Text>
                        </Pressable>
                    )
                })
            }
        </View>
    )
}

interface ISiteMap {
    detectClictEventCb:(event, element)=>void,
    clickMenuLinkCb:(link)=>void
}
export default function SiteMap(props:ISiteMap) {
    const firstRow = SideBarMenus.slice(0, SideBarMenus.length/2 + 1)
    const secondRow = SideBarMenus.slice(SideBarMenus.length/2 + 1,SideBarMenus.length)
    const [hoverItem, setHoverItem] = useState("");
    
    return (
        <View style={{position:"absolute", width:"100%", backgroundColor:"#272b38", paddingLeft:200, paddingTop:50, paddingBottom:74}}>
            <View style={{flexDirection:"row", marginBottom:64}}>
            {
                <FlatList
                    horizontal={true}
                    data={firstRow}
                    renderItem={(category) => <MenuCategoty key={category.item.id} category={category} clickMenuLinkCb={props.clickMenuLinkCb} hoverItem={hoverItem} setHoverItem={setHoverItem}/>}
                    keyExtractor={category=> String(category.id)}
                />
            }
            </View>
            <View style={{flexDirection:"row", marginLeft:MENU_WIDTH}}>
            {
                <FlatList
                    horizontal={true}
                    data={secondRow}
                    renderItem={(category) => <MenuCategoty key={category.item.id} category={category} clickMenuLinkCb={props.clickMenuLinkCb} hoverItem={hoverItem} setHoverItem={setHoverItem}/>}
                    keyExtractor={category=> String(category.id)}
                />
            }
            </View>
        </View>
    )
}